import { useState, useEffect } from 'react';
import { Lock } from 'lucide-react';

export default function CooldownTimer({ endTime }) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const update = () => {
      const diff = Math.max(0, Math.floor((new Date(endTime) - new Date()) / 1000));
      setRemaining(diff);
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [endTime]);

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;

  return (
    <div className="flex items-center gap-2 px-4 py-2 rounded-xl"
      style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)' }}>
      <Lock
        size={16}
        className="text-red-400 lock-animate"
        style={{ animation: remaining > 0 ? 'lockBounce 0.5s ease-in-out infinite' : 'none' }}
      />
      <span className="text-red-400 font-mono font-semibold text-sm">
        Next message in {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
      </span>
    </div>
  );
}
